// Per-destination deep links into the public help docs (datacrow.app/help).
// Meta has its own section; the others share the "connecting your other
// destinations" section for now.
//
// The anchors must match the headings PUBLISHED on the website, which is the
// source of truth, not docs/help-faq.md: the site has since added
// per-destination headings (#connecting-klaviyo and friends) that the in-repo
// FAQ does not carry. The five destinations added on 2026-10-18 point at the
// shared section, which exists but says nothing about them; they are at
// release "hidden", so only a preview shop can reach the link at all. Give
// each one its own published heading when it is flipped (docs/RUNBOOKS.md
// §"Promote a destination").
//
// Shared by the destinations hub + the onboarding wizard so there's a single
// source of truth for the doc URLs.
import { DESTINATION_CATALOG, DESTINATION_TYPES } from "./destination-catalog";

export const HELP_BASE_URL = "https://datacrow.app/help";

// From each catalog entry's helpAnchor (stored without the "#", so a stored
// one cannot produce "help##anchor").
export const DESTINATION_DOCS: Record<string, string> = Object.fromEntries(
  DESTINATION_TYPES.map((t) => [t, `${HELP_BASE_URL}#${DESTINATION_CATALOG[t].helpAnchor}`]),
);
